<ul class="list-group">
    <!-- <li class="list-group-item">
                <a href="#">
                    <i class="fa-solid fa-house fa-fw" style="color: #007bc2;"></i>
                    Dashboard</a>
            </li> -->
    <li class="list-group-item">
        <a routerLink="/manage/appstates" routerLinkActive="active">
            <i class="fas fa-check-double fa-fw d-none d-lg-inline" style="color: #007bc2; font-weight: bold;"></i>
            Approvals</a>
    </li>
    <li class="list-group-item">
        <a routerLink="/manage/partner" routerLinkActive="active">
            <i class="fa-solid fa-handshake fa-fw d-none d-lg-inline" style="color: #007bc2;"></i>
            CSP Management</a>
    </li>
    <li class="list-group-item">
        <a routerLink="/manage/vendor" routerLinkActive="active">
            <i class="fa-brands fa-app-store-ios fa-fw d-none d-lg-inline"
                style="color: #007bc2; font-weight: bold;"></i>
            Vendor Management</a>
    </li>
    <li class="list-group-item">
        <a routerLink="/manage/auditlogs" routerLinkActive="active">
            <i class="fa-solid fa-clipboard-list fa-fw d-none d-lg-inline"
                style="color: #007bc2; font-weight: bold;"></i>
            Audit Logs</a>
    </li>
    <li class="list-group-item">
        <a routerLink="/manage/wflogs" routerLinkActive="active">
            <i class="fa-solid fa-diagram-project d-none d-lg-inline"
                style="color: #007bc2; font-weight: bold;"></i>
            Workflow Logs</a>
    </li>
    <li class="list-group-item d-lg-none" (click)="logout()">
        <a href="javascript:void(0)">
            Logout</a>
    </li>
    <li *ngIf="mngUser && userLastLoginDate" class="list-group-item d-lg-none lastLogin">
        <a href="javascript:void(0)">
            Last Login:&nbsp;{{userLastLoginDate}}</a>
    </li>
</ul>